//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import StateComponent from '@/components/StateComponent.vue';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
export default {
  name: 'InsightsLookerViewer',
  components: {
    StateComponent: StateComponent
  },
  data: function data() {
    return {
      dashboardUrl: '',
      report: null,
      maintenance: true
    };
  },
  created: function created() {
    if (this.$route.params.no_require_agreement || userInfo.somos1_agreement) {
      this.getReport(this.$route.params.report_id);
    } else {
      this.$router.push({
        name: 'somos1_list'
      });
    }
  },
  methods: {
    getReport: function getReport(reportId) {
      var _this = this;
      Somos1Service.getSomos1Report(reportId).then(function (response) {
        _this.report = response.data;
        _this.dashboardUrl = _this.report.link + '?v1=' + _this.report.code;
        _this.maintenance = _this.report.maintenance;
        console.log(_this.dashboardUrl, 'dashboardUrl');
      });
    }
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.somos1_reports'),
        disabled: true,
        href: '/#/customer_insights/'
      }, {
        text: this.$route.params.title,
        disabled: false,
        href: '/#/customer_insights/' + this.$route.params.link
      }];
    }
  }
};